import { InjectionToken } from '@angular/core';

export type Language = 'fr' | 'nl';

export interface CultureConfig {
    appLanguages: Language[];
    fallbackLanguage: Language;
}

export const CULTURE_CONFIG = new InjectionToken<CultureConfig>('Culture/Language used when app startup', {
    factory: () => ({
        appLanguages: ['fr', 'nl'],
        fallbackLanguage: 'fr',
    }),
});
